'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:ChangeShiftStartController
 * @description
 * # MoveToOtherDayController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ChangeShiftStartController', ['$uibModalInstance', '$scope', 'data', function ($uibModalInstance, $scope, data) {


      $scope.model = { startTime: new Date(moment(data.startTime, 'HH:mm a')), originalTime: new Date(moment(data.startTime, 'HH:mm a')) };
     
      $scope.close = function () {
          $uibModalInstance.close({ time: moment($scope.model.startTime).format('hh:mm A') });
      };

      $scope.dismiss = function () {
          $uibModalInstance.dismiss();
      };

      $scope.timeChanged = function () {
          return !moment($scope.model.startTime).isSame($scope.model.originalTime);
      };

  }]);